export const AMLQuestionnaireCodes = [
  'MODULO_ANTIRICICLAGGIO',
  'CAMBIO_RECAPITO_SERVIZI_DIGITALI',
] as const;

export const DIY_ONBOARDING_CODE = 'ONBOARDING_NUOVO_CLIENTE';

export const MiFiQuestionnaireCodes = ['QUESTIONARIO_MIFID'] as const;

export const RtoImiOrderCodes = [
  'MODULO_ORDINE_RTO',
  'VERSAMENTO_RTO_IMI',
  'PRELIEVO_RTO_IMI',
] as const;

export const NgaOrderCodes = [
  'VERSAMENTO_NGA',
  'PRELIEVO_NGA',
  'RENDICONTO_NGA',
  'VERSAMENTO_NGA_SMART',
  'PRELIEVO_NGA_SMART',
  'RENDICONTO_NGA_SMART',
] as const;

export const AdvancedInvestmentProposalCodes = [
  'VERSAMENTO_AGGIUNTIVO_MAX',
  'PRELIEVO_A_VALERE_SUL_SERVIZIO_CONTO_DEPOSITO_MAX',
] as const;

export const InvestmentProposalCodes = [
  'REPORT_PROPOSTA',
  'MODULO_ORDINE',
  ...AdvancedInvestmentProposalCodes,
] as const;

export const DigitalServicesSubscriptionCodes = [
  'ADESIONE_SERVIZI_DIGITALI',
] as const;

export const AdesioneServiziDigitaliCodes = [
  'ADESIONE_SERVIZI_DIGITALI',
] as const;

export const AccordoQuadroSgrCodes = ['ACCORDO_QUADRO_SGR'] as const;

export const AccordoQuadroAfiCodes = ['ACCORDO_QUADRO_AFI'] as const;

export const CopertureCodes = ['COPERTURE_AGGIUNTIVE_INFINITY'] as const;

export const GenericDocumentCodes = [
  'ADESIONE_SERVIZIO_SOLIDARIETA_AZ_FUND',
  'REPORT_CONSULENZA_ASSICURATIVA',
  'LETTERA_RIMBORSO_FIA_CAPITALE_ALI',
  'LETTERA_RIMBORSO_PROVENTO_ALI',
  'LETTERA_RIMBORSO_PROVENTO_ACM',
  'COPERTURE_AGGIUNTIVE_NAVIGATOR',
  'CASE_TERZE_COMUNICAZIONI_AZIONISTI',
  'LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ACM',
  'LETTERA_ISTRUZIONE_PROVENTO_RTO',
  'LETTERA_RICHIAMO_FIA_PROD_NON_PIR_DESC_ALI',
  'LETTERA_CONFERMA_FIA_PAGAMENTO_ACM',
  'AUDIT_TRAIL',
  'MODULO_ADDENDUM',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_COMMISSIONI_ALI',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_SENZA_COMMISSIONI_ACM',
  'RICHIESTA_APERTURA_CONTO_EAM',
  'DISTRIBUZIONE_DIVIDENDI',
  'VERSAMENTO_AGGIUNTIVO_MAX_BNP',
  'LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ALI',
  'INFORMATIVA_INDIVIDUALE_AGGIORNAMENTO',
  'LETTERA_TRASFERIMENTO_FIA_EREDI_ACM',
  'INFORMATIVA_ASSET_TIMING_AZFUND',
  'LETTERA_FIA_RICHIESTA_FISCALITA_BOLLO_MONTI_ALI',
  'AZIMUT_PREVIDENZA_MODIFICA_CONVENZIONE_ASSICURATIVA_RENDITE',
  'GEST_PATRIMONIALI_CARTACEI',
  'RTO',
  'MYAZIMUT_INFORMATIVA_PRIVACY',
  'RTO_OMNIBUS',
  'MAX_FUND',
  'ADESIONE_SERVIZI_DIGITALI',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_NON_PIR_ALI',
  'DOCUMENTO_INFORMATIVO_FUSIONI_COMPARTI_AZFUND',
  'GEST_PATRIMONIALI_EXPOST_CONTI_CHIUSI',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CESSIONARIO_ALI',
  'INFORMATIVA_ACM_SIA',
  'LETTERA_RIMBORSO_FIA_PROVENTO_ALI',
  'INFORMATIVA_INDIVIDUALE_AZALLOCATION',
  'MODULO_ORDINE_RTO',
  'AZFUND_GIORNALIERE',
  'PROCURA_ORDINARIA',
  'ALTROSOGGETTO_ES_AZ_SFUTURE',
  'INFORMATIVA_PRIVACY_AZ_THEMATIC_FUND',
  'RIDUZIONE_COMMISSIONALE',
  'CONFERMA_OPERAZIONE_AZFUND_SEMESTRALE',
  'CONFERMA_REINVESTIMENTO_DIVIDENDI',
  'LETTERA_BENVENUTO_PIR',
  'GEST_PATRIMONIALI',
  'CORPORATE_ACTION_RTO',
  'LETTERA_CONFERMA_FIA_RICEZIONE_VERSAMENTO_ALI',
  'INFORMATIVA_INDIVIDUALE_AZ_DIRECT_INVESTMENT',
  'MYAZIMUT_INFORMATIVA_PRIVACY_DOB',
  'CONFERMA_FONDO_AZSUSTAINABLE_FUTURE',
  'DOCUMENTO_INFORMATIVO_COMPARTI_AZFUND1',
  //'APERTURA_DEPOSITO_PIR_ALT',
  'VARIAZIONE_OFFERTA_FONDI',
  'KIID_PAPER',
  'RTO_EXPOST',
  'OPUSCOLO_INFORMATIVO',
  'INFORMATIVA_INDIVIDUALE_AZFUND_AZBOND',
  'LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ALI',
  'LETTERA_ISTRUZIONE_PIR_ALTERNATIVE',
  'PERDITE_MIFID_GESTIONI',
  'INFORMATIVA_INDIVIDUALE_AZFUND_MULTIASSET',
  'PRELIEVO_RTO_BPM',
  //'APERTURA_GOAL_BASED_PLAN',
  'GEST_PATRIMONIALI_EXPOST',
  'ALTROSOGGETTO_CON_AZ_PREVIDENZA',
  'RTO_CHIUSI',
  'CAMBIO_RECAPITO_SERVIZI_DIGITALI',
  'LETTERA_BENVENUTO_NGA',
  'LETTERA_FIA_RICHIESTA_FISCALITA_BOLLO_MONTI_ACM',
  'LETTERA_GESTIONI_OMNIBUS',
  'ADEGUATA_VERIFICA',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CEDENTE_ACM',
  'INFORMATIVA_ACM_FORMULA1',
  'COPERTURE_AGGIUNTIVE_GALAXY',
  'KIID',
  'NOTE_INFORMATIVE',
  'LETTERA_BENVENUTO_AFI_ADDENDUM',
  'CARTA_IDENTITA',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_PIR_ALI',
  'INFORMATIVA_INDIVIDUALE_ACM_MODIFICHE',
  'SISTEMA_INVESTIMENTO_AZIMUT_AGGIORNAMENTO',
  'VERSAMENTO_NGA',
  'ADESIONE_SERVIZIO_SOLIDARIETA_AZ_ITA',
  'LETTERA_FIA_PAGAMENTO_FISCALITA_PIR_ALI',
  'POSIZIONE_RIEPILOGATIVA',
  'PREVIDENZA_GIORNALIERE',
  'NEWS',
  'IDENTITY_DOCUMENT',
  'MODIFICA_DISTRIBUZIONE_PROVENTI',
  'AZFUND_IRLANDESI',
  'ADESIONE_SERVIZI_DIGITALI_DOB',
  'MODULO_DINIEGO_AZ_GLOBAL_PRIVATE_DEBT_EVERGREEN_RAIF',
  'PRELIEVO_A_VALERE_SUL_SERVIZIO_CONTO_DEPOSITO_MAX',
  'LETTERA_ISTRUZIONE_PROVENTO_EY',
  'TRATTAMENTO_COMMISSIONALE',
  'APERTURA_SERVIZI_INVESTIMENTO',
  'LETTERA_BENVENUTO_GOAL_BASED_PLAN',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_COMMISSIONI_ACM',
  'COPERTURE_AGGIUNTIVE_INFINITY',
  'PRELIEVO_NGA',
  'LETTERA_RICHIAMO_FIA_PROD_PIR_DESC_ALI',
  'RENDICONTO_NGA',
  'LETTERA_CONFERMA_FIA_PAGAMENTO_ALI',
  'PRELIEVO_RTO_BNP',
  'AZIMUT_PREVIDENZA_CHIUSURA_COMPARTO_GARANTITO',
  'AVVISO_AZ_GLOBAL_PRIVATE_DEBT_EVERGREEN_RAIF',
  'SCHEDA_PEP',
  'DICHIARAZIONI_PRELIMINARI',
  'LETTERA_RICHIAMO_FIA_PROD_NON_PIR_DESC_ACM',
  'CASE_TERZE_GIORNALIERE',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_NON_PIR_ACM',
  'LETTERA_INDIVIDUALE_GESTIONI_TOP_TEN',
  'VARIAZIONE_UNILATERALE',
  'INFORMATIVA_INDIVIDUALE_AZBOND',
  'INTERNAL_GENERIC_FEQ',
  'APRIMI_INVITO_ALI_VIRTUAL_EXPO',
  'LETTERA_CONFERMA_FIA_INVESTIMENTO_SENZA_COMMISSIONI_ALI',
  'PRELIEVO_RTO_IMI',
  'INFORMATIVA_INDIVIDUALE_AZFUND',
  'DOCUMENTO_INFORMATIVO_COMPARTI_AZBOND',
  'AZ_LIFE_RID',
  'LETTERA_AZIMUT_INVESTMENTS_OPHELIA',
  'MODULO_ORDINE',
  'MAX',
  'LETTERA_TRASFERIMENTO_FIA_EREDI_ALI',
  'LETTERA_FIA_CERTIFICAZIONE_MINUSVALENZE_ACM',
  'DISTRIBUZIONE_PROVENTI',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CESSIONARIO_ACM',
  'LETTERA_BENVENUTO_MAX',
  'LETTERA_BENVENUTO_NGA_SMART',
  'VERSAMENTO_AGGIUNTIVO_MAX',
  'INTERNAL_GENERIC_FEQDOB',
  'SPECIMENT',
  'INFORMATIVA_INDIVIDUALE_MULTIASSET',
  'INFORMATIVA_INDIVIDUALE_ALISEO_MODIFICHE',
  'COMUNICAZIONE_INFORMATIVA_DEPOSITO_PIR',
  'CONFERME_GIORNALIERE_FONDI',
  'AGGIORNAMENTO_DATI_PERIODICI_FORMULA1',
  'ARCHIVED_CONTRACTS',
  'LETTERA_RIMBORSO_FIA_CAPITALE_ACM',
  'OFFERTA_INFORMATIVA',
  'PRELIEVO_MAX',
  'CONFERMA_ORDINE_BOLLO_MONTI',
  'COMUNICAZIONE_AVVIO_SERVIZIO_CONSULENZA',
  'LETTERA_RIMBORSO_FIA_PROVENTO_ACM',
  'POSIZIONI_ANIMA_SGR',
  'COPERTURE_AGGIUNTIVE_UNIVERSAL',
  'INFORMATIVA_CLIENTI_SISTEMA_INVESTIMENTO_AZIMUT_AGGIORNAMENTO_DATI',
  'RENDICONTO_CDL',
  'RENDICONTO_BOLLO_MONTI_CHIUSURA',
  'LETTERA_BENVENUTO_SGR',
  'DISTRIBUZIONE_PROVENTI_GALAXY',
  //'APERTURA_CDL',
  'ACCORDO_QUADRO_SGR',
  'VERSAMENTO_NGA_SMART',
  'DOCUMENTO_INFORMATIVO_FUSIONI_FONDI_AZIMUT_CAPITAL',
  'GUIDA_PORTALI_CLIENTI',
  'VERSAMENTO_RTO_BPM',
  'LETTERA_CONFERMA_FIA_RICEZIONE_VERSAMENTO_ACM',
  'GPM_NUOVE_LINEE',
  'RENDICONTO_PIR_ALTERNATIVE',
  'DOCUMENTAZIONE_ANAGRAFICA',
  'MAX_EX_POST',
  'INFORMATIVA_INDIVIDUALE_AZ_SCA_SICAV_RAIF',
  'MOSAICO',
  'LETTERA_INDIVIDUALE_GESTIONI_ETF',
  'ADEGUATA_VERIFICA_DOB',
  'VERSAMENTO_RTO_BNP',
  'RENDICONTO_PIR',
  'RENDICONTO_COSTI_EXPOST_BASE',
  'MODULO_CONSENSO_AZ_GLOBAL_PRIVATE_DEBT_EVERGREEN_RAIF',
  'GP_CONFERIMENTO_PROCURA_ORDINARIA',
  'LETTERA_TRASFERIMENTO_FIA_QUOTE_CEDENTE_ALI',
  'INFORMATIVA_INDIVIDUALE_AZFUND_AZALLOCATION',
  'CONSULENZA_BASE_EXPOST',
  'PRELIEVO_NGA_SMART',
  'MAX_OMNIBUS',
  'COMUNICAZIONE_INFORMATIVA_PIR_BOX',
  'LETTERA_RICHIAMO_FIA_MULTIRICHIAMO_ACM',
  'AGGIORNAMENTO_DATI_PERIODICI_SISTEMA_INVESTIMENTO_AZIMUT',
  'LETTERA_CON_ALLEGATO',
  'LETTERA_GESTIONI',
  'LETTERA_BENVENUTO_AFI',
  'CONFERME_NUOVE_GESTIONI_PATRIMONIALI',
  'REPORT_PROPOSTA',
  'MODULO_ANTIRICICLAGGIO',
  'RENDICONTO_NGA_SMART',
  'SCHEDA_TITOLARE_EFFETTIVO',
  'ACCORDO_QUADRO_AFI',
  'MODULO_ORDINE_PAPER',
  'ALTROSOGGETTO_ES_AZ_PREVIDENZA',
  'LETTERA_FIA_PAGAMENTO_FISCALITA_PIR_ACM',
  'MAX_FUND_EX_POST',
  'VERSAMENTO_RTO_IMI',
  'PERDITE_MIFID_AMMINISTRATO',
  'LETTERA_DIVIDENDI',
  'PROMO_PIR_BOX',
  'ALTROSOGGETTO_CON_AZ_SFUTURE',
  'INFORMATIVA_INDIVIDUALE_AZRAIF',
  'REPORT_PROPOSTA_PAPER',
  'INFORMATIVA_INDIVIDUALE_MULTIASSET_BTPORTFOLIO',
  'QUESTIONARIO_MIFID',
  'LETTERA_RICHIAMO_FIA_PRODOTTO_PIR_ACM',
  'QUESTIONARIO_MIFID_DOB',
  'RTO_EXPOST_CONTI_CHIUSI',
  'COMUNICAZIONE_PIANI_RISPARMIO_PIR',
] as const;

export const SchedaFinanziariaTitle =
  'Scheda finanziaria V.2 (Questionario Mifid Persone Fisiche)' as const;
export const ContrattoMyAzimut = 'Contratto My Azimut' as const;
export const ModuloAperturaRapporti = 'Modulo appertura rapporti' as const;
export const ModuloAperturaRapportiAFI =
  'Modulo appertura rapporti AFI' as const;

export const SignatureDocumentCodes = [
  ...AMLQuestionnaireCodes,
  ...MiFiQuestionnaireCodes,
  ...RtoImiOrderCodes,
  ...NgaOrderCodes,
  ...InvestmentProposalCodes,
  ...DigitalServicesSubscriptionCodes,
  ...AdesioneServiziDigitaliCodes,
  ...AccordoQuadroSgrCodes,
  ...AccordoQuadroAfiCodes,
  ...CopertureCodes,
  ...GenericDocumentCodes,
] as const;

export const SignatureDocumentCodeFiduciaria = [
  ...AMLQuestionnaireCodes,
  ...DigitalServicesSubscriptionCodes,
  ...AdesioneServiziDigitaliCodes,
];

export type AMLQuestionnaireTypes = (typeof AMLQuestionnaireCodes)[number];
export type MiFiQuestionnaireTypes = (typeof MiFiQuestionnaireCodes)[number];
export type RtoImiOrderTypes = (typeof RtoImiOrderCodes)[number];
export type NgaOrderTypes = (typeof NgaOrderCodes)[number];
export type InvestmentProposalTypes = (typeof InvestmentProposalCodes)[number];
export type AdesioneServiziDigitaliTypes =
  (typeof AdesioneServiziDigitaliCodes)[number];
export type AccordoQuadroSgrTypes = (typeof AccordoQuadroSgrCodes)[number];
export type AccordoQuadroAfiTypes = (typeof AccordoQuadroAfiCodes)[number];
export type CoperturTypes = (typeof CopertureCodes)[number];
export type GenericDocumentTypes = (typeof GenericDocumentCodes)[number];
